export const getConnectionIcon = (status: string): string => {
  let text = '-'

  switch (status) {
    case 'CONNECTED':
    case 'SUCCESS':
      text = 'connected'
      break
    case 'NOT_CONNECTED':
    case 'ERROR':
      text = 'not-connected'
      break
    case 'PROCESSING':
      text = 'processing'
      break
    case 'CREATING':
      text = 'creating'
      break
    default:
      text = 'unknown'
      break
  }

  return text
}
